export type ActivationTarget = { kind: "app" } | { kind: "chrome"; extensionId: string };

/**
 * What the portal was opened to do. The ConfCap app sends people to the portal with ?activate=app, and the Chrome extension with
 * ?chrome=<its id>; after they sign in, the portal hands the chosen stream back to it.
 */
export function activationTarget(search: string): ActivationTarget | null {
  const args = new URLSearchParams(search);
  if (args.get("activate") === "app") return { kind: "app" };
  const extensionId = args.get("chrome");
  return extensionId ? { kind: "chrome", extensionId } : null;
}

export function activationUrl(target: ActivationTarget, streamName: string, uid: string): string {
  return target.kind === "app"
    ? `confcap://open-stream?name=${streamName}&uid=${uid}`
    : `chrome-extension://${target.extensionId}/options.html?stream=${streamName}&uid=${uid}`;
}
